import { render, staticRenderFns } from "./ProductForm.vue?vue&type=template&id=35598868&scoped=true&"
import script from "./ProductForm.vue?vue&type=script&lang=ts&"
export * from "./ProductForm.vue?vue&type=script&lang=ts&"
import style0 from "./ProductForm.vue?vue&type=style&index=0&id=35598868&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35598868",
  null
  
)

export default component.exports